// Styled components
import {
  P,
  SkillImg,
  SkillsCardsWrapper,
  SkillsClassification,
  SkillsHeading,
  SkillsSectionWrapper,
  SkillWrapper,
} from "./Skills.style";

// import icons
import JsIcon from "../../assets/icons/javascript.png";
import ReactIcon from "../../assets/icons/react.png";
import HtmlIcon from "../../assets/icons/html5.png";
import CssIcon from "../../assets/icons/css3.png";
import NodeIcon from "../../assets/icons/node-js.png";
import FirebaseIcon from "../../assets/icons/firebase.png";
import GitIcon from "../../assets/icons/git.png";
import TsIcon from "../../assets/icons/typescript.png";
import PgIcon from "../../assets/icons/postgresql.png";
import GitHubIcon from "../../assets/icons/github.png";
import SCIcon from "../../assets/icons/styled-components.png";
import ExpressIcon from "../../assets/icons/express.png";
import HerokuIcon from "../../assets/icons/heroku.png";
import MongoDbIcon from "../../assets/icons/mongodb.png";
import NetlifyIcon from "../../assets/icons/netlify.png";

const Skills = () => {
  return (
    <SkillsSectionWrapper id="skills">
      <SkillsHeading>Skills</SkillsHeading>
      <SkillsClassification>
        <strong>Front-end</strong>
      </SkillsClassification>
      <SkillsCardsWrapper>
        <SkillWrapper>
          <SkillImg src={TsIcon} alt="icon image" />
          <P>TypeScript</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={JsIcon} alt="icon image" />
          <P>JavaScript</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={ReactIcon} alt="icon image" />
          <P>ReactJS</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={SCIcon} alt="icon image" />
          <P>Styled-Components</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={HtmlIcon} alt="icon image" />
          <P>HTML</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={CssIcon} alt="icon image" />
          <P>CSS</P>
        </SkillWrapper>
      </SkillsCardsWrapper>
      <SkillsClassification>
        <strong>Back-end</strong>
      </SkillsClassification>
      <SkillsCardsWrapper>
        <SkillWrapper>
          <SkillImg src={NodeIcon} alt="icon image" />
          <P>NodeJS</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={ExpressIcon} alt="icon image" />
          <P>ExpressJS</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={MongoDbIcon} alt="icon image" />
          <P>MongoDB</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={PgIcon} alt="icon image" />
          <P>PostgreSQL</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={FirebaseIcon} alt="icon image" />
          <P>Firebase</P>
        </SkillWrapper>
      </SkillsCardsWrapper>
      <SkillsClassification>
        <strong>Other</strong>
      </SkillsClassification>
      <SkillsCardsWrapper>
        <SkillWrapper>
          <SkillImg src={GitIcon} alt="icon image" />
          <P>Git</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={GitHubIcon} alt="icon image" />
          <P>GitHub</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={HerokuIcon} alt="icon image" />
          <P>Heroku</P>
        </SkillWrapper>
        <SkillWrapper>
          <SkillImg src={NetlifyIcon} alt="icon image" />
          <P>Netlify</P>
        </SkillWrapper>
      </SkillsCardsWrapper>
    </SkillsSectionWrapper>
  );
};

export default Skills;
